var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUserFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7692 5.85833C13.7692 7.9202 12.0816 9.59167 9.99994 9.59167C7.91825 9.59167 6.23071 7.9202 6.23071 5.85833C6.23071 3.79647 7.91825 2.125 9.99994 2.125C12.0816 2.125 13.7692 3.79647 13.7692 5.85833Z",
    fill: "#1C1C28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.3471C3 13.2052 5.44606 10.6582 8.46342 10.6582H11.5366C14.5539 10.6582 17 13.2052 17 16.3471C17 17.3289 16.2356 18.1249 15.2927 18.1249H4.70732C3.76439 18.1249 3 17.3289 3 16.3471Z",
    fill: "#1C1C28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFill);
export default __webpack_public_path__ + "static/media/iconUserFill.a0053e49.svg";
export { ForwardRef as ReactComponent };